import React, {useEffect, useState} from "react";
import TooltipTrigger from "../bootstrap/TooltipTrigger";
import {JSON_HEADERS} from "../../constants/constants";

export default function Follow({item, itemType, userSignedIn, currentUser, token, hoverBg, condenseOnMobile }) {

    // this component assumes that the user is signed in

    const [following, setFollowing] = useState(!!item.subscription_id);
    const [subscriptionId, setSubscriptionId] = useState(item.subscription_id);

    const onFollow = async() => {
        if(following && subscriptionId) {
            await fetch(`/user_posting_subscriptions/${subscriptionId}/unsubscribe`, { method: 'GET', headers: JSON_HEADERS });
            setSubscriptionId(null);
            setFollowing(false);
        } else {
            let itemKey = `${itemType}_id`, data = {};
            data[itemKey] = item.id;
            data['authenticity_token'] = token;
            data['user'] = currentUser;

            await fetch('/user_posting_subscriptions', {
                method: 'POST',
                headers: JSON_HEADERS,
                body: JSON.stringify(data)
            }).then(function(response) {
                return response.json();
            }).then(function(jsonResponse) {
                if(jsonResponse.subscription) {
                    setSubscriptionId(jsonResponse.subscription.id);
                    setFollowing(true);
                }
            });
        }
    }

    return (
        <TooltipTrigger id={`follow_${item.id}`} placement={'top'} content={ following ? 'Click to unfollow' : 'Follow this post'}>
            <a
                data-after-signin-redirect={item.actions.url}
                data-external-only={1}
                className={`p-2 link-secondary font-14 hover-bg-${hoverBg} ${!userSignedIn && 'gitb-modal-register-open' }`}
                onClick={() => onFollow() }>
                <i className={`fal me-2 fa-user-${ following ? 'minus' : 'plus'}`}></i>
                <span className={`fw-bold ${condenseOnMobile && 'd-none d-sm-inline-block'}`}>{ following ? 'Following' : 'Follow'}</span>
            </a>
        </TooltipTrigger>
    )
}